import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyeSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEyeSparkle"><Path d="M2 12C6.82745 2.00007 17.1725 1.99995 22 11.9999C17.1725 21.9999 6.82745 22 2 12Z" stroke="currentColor" strokeLinecap="round"/><Path d="M12.4 8H11.6L10.6 10.6L8 11.6V12.4L10.6 13.4L11.6 16H12.4L13.4 13.4L16 12.4V11.6L13.4 10.6L12.4 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEyeSparkle;
